var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Page"},[_c('HeaderSection',{attrs:{"title":"Colofon","closeLinkTo":{ name: 'home'}}},[_c('p',[_vm._v("\n      Hi there!\n    ")])]),_c('ContentSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }